module.exports = __webpack_public_path__ + "img/button@2x.11d88e7a.png";